module.exports = __webpack_public_path__ + "img/img_ghost_10@3x.72f19319.png";